import * as Yup from 'yup';
import {ISessionRoles} from '~/modules/Profile/session';


export enum PermissionResourceType {
    AGENCY = 'agency',
    SELLER = 'seller',
    MEDIATIONPARTNER = 'mediation_partner'
}

export const MediationPartnerType = {
    Default: 0,
    ApplovinMAX: 1,
    Bidon: 2,
    IronSource: 3,
    Chartboost: 4,
    Topon: 5,
    Naver: 6,
    CloudX: 8,
} as const;

// TODO: Hate enums
export const permissionResourceTypes = Object.values(PermissionResourceType) as PermissionResourceType[];
export const mediationPartnerTypes = Object.keys(MediationPartnerType) as unknown as keyof typeof MediationPartnerType;

export interface IUserPermission {
    userId: number;
    resourceId: number;
    resourceType: PermissionResourceType;
}

export const UserPermissionSchema = Yup.object().shape<IUserPermission>({
    userId: Yup.number().min(1).required(),
    resourceId: Yup.number().min(0).required(),
    resourceType: Yup.mixed<PermissionResourceType>().test({
        name: 'type',
        message: 'type is invalid',
        test: (value: PermissionResourceType) : value is PermissionResourceType => permissionResourceTypes.findIndex(role => role === value) !== -1,
    }).required()
});

export const defaultUserPermission: IUserPermission = {
    userId: 0,
    resourceId: 0,
    resourceType: null
};
